import { apiFetch } from './client';
import type { HRRequest, HRRequestType, ReasonCategory } from '$lib/types';

export interface HRRequestBody {
  type: HRRequestType;
  start_date: string;
  end_date?: string;
  half_day?: boolean;
  reason_category?: ReasonCategory | '';
  reason: string;
  // leave_type_id is required by the server for new type=leave requests (see
  // buildLeaveRequest in hr_requests.go) — omitted for every other type.
  leave_type_id?: number;
}

// hrRequestsApi is the employee-facing CRUD for /hr_requests (own requests
// only — the server scopes every query to the caller's user_id).
export const hrRequestsApi = {
  list: () => apiFetch<HRRequest[]>('/hr_requests'),
  create: (body: HRRequestBody) =>
    apiFetch<HRRequest>('/hr_requests', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: HRRequestBody) =>
    apiFetch<HRRequest>(`/hr_requests/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<null>(`/hr_requests/${id}`, { method: 'DELETE' })
};
